import {
    CREATEPID,
    HISTORY_OF_PID,
    LISTOFPID,
    VIEWPID,
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const createPID = async (data: object) => {
    const response = await authData.post(CREATEPID, data);
    return response?.data;
  };

  export const listOfPID  = async (data: object) => {
    const response = await authData.post(LISTOFPID, data);
    return response?.data;
  };
  
  export const viewPID  = async (id: number) => {
    const response = await authData.get(`${VIEWPID}/${id}`);
    return response?.data;
  };
  
  export const historyOfPID  = async (id: number, data: object) => {
    const response = await authData.post(`${HISTORY_OF_PID}/${id}`, data);
    return response?.data;
  };
